import React from 'react';
import { Tooltip, Tag } from 'components';
import { capitalize } from 'utils';
import { DocumentType } from './types';

type DocumentTagProps = {
  status: string;
  isDeleted?: boolean;
  reason?: string;
  documentType: DocumentType['documentType'];
};

const DocumentTag: React.FC<DocumentTagProps> = ({
  status,
  isDeleted,
  reason,
  documentType,
}) => {
  const getColor = () => {
    if (isDeleted) return 'gray6';
    if (documentType !== 'listingAgreement') return 'primary';

    if (status === 'pending') return 'warning';
    if (status === 'accepted') return 'success';
    return 'danger';
  };

  const getLabel = () => {
    if (isDeleted) {
      if (documentType === 'listingAgreement') {
        return 'Replaced';
      }
      return 'Archived';
    }
    if (documentType !== 'listingAgreement') return 'Submitted';

    let label = capitalize(status);
    if (status === 'pending') label = 'Pending Review';

    return label;
  };

  const StatusTag = (
    <Tag color={getColor()} hideMargin>
      {getLabel()}
    </Tag>
  );

  if (
    !isDeleted &&
    status === 'rejected' &&
    documentType === 'listingAgreement'
  ) {
    return (
      <Tooltip title={reason} placement="bottom">
        <span>{StatusTag}</span>
      </Tooltip>
    );
  }

  return StatusTag;
};

export default DocumentTag;
